export const SubscriptionItem = {
  SubscriptionItem: 'wellness-subscription-item',
  SubscriptionActiveItem: 'wellness-subscription-active',
  SubscriptionActiveItemCancelBtn: 'wellness-subscription-active-cancel-btn',
  SubscriptionInactiveItem: 'wellness-subscription-inactive',
  SubscriptionInactiveItemSubscribeBtn: 'wellness-subscription-inactive-subscribe-btn',
} as const;
